import { LOGOUT_ROUTE } from 'commons/constants/app';
import { lazy } from 'react';

import * as PERMISSIONS from 'commons/constants/permissions';
import { Route } from '../commons/types/routes';

const VeículoFigurante = lazy(() => import('../pages/VehicleFigurant'));
const HomePage = lazy(() => import('../pages/Home'));
const AnimalFigurant = lazy(() => import('../pages/AnimalFigurant'));
const Figurant = lazy(() => import('../pages/Figurant'));
const InspectorFigurant = lazy(() => import('../pages/InspectorFigurant'));
const OrdersFiltered = lazy(() => import('../pages/OrdersFiltered'));
const OrdersFigurant = lazy(() => import('../pages/OrdersFigurant'));
const SearchFigurant = lazy(() => import('../pages/SearchFigurant'));
const SelectFigurant = lazy(() => import('../pages/SelectFigurant'));
const SelectFigurantWithResponsible = lazy(() => import('../pages/SelectFigurantWithResponsible'));
const ViewMore = lazy(() => import('../pages/ViewMore/ViewMorePage'));
const Logout = lazy(() => import('../pages/Auth/Logout'));
const RequestFigurant = lazy(() => import('../pages/RequestFigurant'));
const ContentManagement = lazy(() => import('../pages/ContentManagement'));
const DailyFigurations = lazy(() => import('../pages/DailyFigurations'));
const CheckOrders = lazy(() => import('../pages/InvoiceLetter/CheckOrders'));
const GenerateInvoiceLetter = lazy(() => import('../pages/InvoiceLetter/Generate'));
const Realize = lazy(() => import('../pages/InvoiceLetter/Realize'));
const SearchInvoiceLetter = lazy(() => import('../pages/InvoiceLetter/Search'));

const SearchLicense = lazy(() => import('../pages/License/Search'));
const RegisterLicense = lazy(() => import('../pages/License/RegisterOrEdit'));
const ViewMoreLicense = lazy(() => import('../pages/License/ViewMore'));
const SearchCheckIn = lazy(() => import('../pages/CheckIn/Search'));
const Reports = lazy(() => import('../pages/Reports'));
const ReportRecord = lazy(() => import('../pages/RecordReport'));

const DocumentSigning = lazy(() => import('../pages/DocumentSigning'));

const ApproveProducer = lazy(() => import('../pages/ApproveProducer'));

const TransportSecurity = lazy(() => import('../pages/TransportSecurity/TransportSecurity'));

const allResourcers = Object.values(PERMISSIONS);
const ListRecordingReportPage = lazy(() => import('../pages/RecordingReport/pages/ListRecordingReportPage'));
const RecordingReportAndOccurrencesPage = lazy(
  () => import('../pages/RecordingReport/pages/RecordingReportAndOccurrencesPage')
);

const routes: Route[] = [
  {
    path: '/',
    component: HomePage,
    permission: allResourcers,
  },
  {
    path: '/animal-figurante',
    component: AnimalFigurant,
    permission: [PERMISSIONS.CADASTRO_FIGURANTE_ANIMAL],
    title: 'Cadastro de animal',
  },
  {
    path: '/animal/:id/editar',
    component: AnimalFigurant,
    permission: [PERMISSIONS.CADASTRO_FIGURANTE_ANIMAL],
    title: 'Edição de animal',
  },
  {
    path: '/busca-por-figurante',
    component: SearchFigurant,
    permission: [PERMISSIONS.BUSCA_GERAL, PERMISSIONS.BUSCA_FIGURANTE, PERMISSIONS.BUSCA_FISCAL],
    title: 'Busca por Figurante',
  },
  {
    path: '/busca-por-alvara',
    component: SearchLicense,
    permission: [PERMISSIONS.CADASTRO_FIGURANTE_ALVARA],
    title: 'Busca por alvará',
  },
  {
    path: '/fiscal-de-figurante',
    component: InspectorFigurant,
    permission: [PERMISSIONS.CADASTRO_FIGURANTE_FISCAL],
    title: 'Cadastro de Fiscal',
  },
  {
    path: '/figurante',
    component: Figurant,
    permission: [PERMISSIONS.CADASTRO_FIGURANTE],
    title: 'Cadastro de figurante',
  },
  {
    path: '/veiculo-figurante',
    component: VeículoFigurante,
    permission: [PERMISSIONS.CADASTRO_FIGURANTE_VEICULO],
    title: 'Cadastro de veículo',
  },
  {
    path: '/ver-mais/:type/:id',
    component: ViewMore,
    permission: [PERMISSIONS.BUSCA_GERAL, PERMISSIONS.BUSCA_FIGURANTE, PERMISSIONS.BUSCA_FISCAL],
    title: 'Detalhe do figurante',
  },
  {
    path: LOGOUT_ROUTE,
    component: Logout,
    permission: allResourcers,
  },
  {
    path: '/figurante/:figurantId/editar',
    component: Figurant,
    permission: [PERMISSIONS.CADASTRO_FIGURANTE],
    title: 'Edição de Figurante',
  },
  {
    path: '/fiscal/:id/editar',
    component: InspectorFigurant,
    permission: [PERMISSIONS.CADASTRO_FIGURANTE_FISCAL],
    title: 'Edição de Fiscal',
  },
  {
    path: '/veiculo/:id/editar',
    component: VeículoFigurante,
    permission: [PERMISSIONS.CADASTRO_FIGURANTE_VEICULO],
    title: 'Edição de veículo',
  },
  {
    path: '/solicitacao-figurante',
    component: RequestFigurant,
    permission: [PERMISSIONS.SOLICITACAO_PEDIDO_FIGURACAO],
    title: 'Solicitação de figuração',
  },
  {
    path: '/extensao/:id',
    component: RequestFigurant,
    permission: [PERMISSIONS.SOLICITACAO_PEDIDO_FIGURACAO],
    title: 'Extensão de jornada',
  },
  {
    path: '/extensao/escalar-figurantes/:id/agencia/:agencyId/item/:itemId',
    component: SelectFigurant,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/escalar-figurantes/:id/agencia/:agencyId/item/:itemId',
    component: SelectFigurant,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/escalar-fiscais/:id/agencia/:agencyId/item/:itemId',
    component: SelectFigurant,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de fiscais',
  },
  {
    path: '/escalar-fiscais/:id/agencia/:agencyId/item/:itemId/editar',
    component: SelectFigurant,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de fiscais',
  },
  {
    path: '/escalar-menor/:id/agencia/:agencyId/item/:itemId',
    component: SelectFigurant,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/escalar-menor-emancipado/:id/agencia/:agencyId/item/:itemId',
    component: SelectFigurant,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/escalar-veiculos/:id/agencia/:agencyId/item/:itemId',
    component: SelectFigurantWithResponsible,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/escalar-animais/:id/agencia/:agencyId/item/:itemId',
    component: SelectFigurantWithResponsible,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/escalar-figurantes/:id/agencia/:agencyId/item/:itemId/editar',
    component: SelectFigurant,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/escalar-profissional/:id/agencia/:agencyId/item/:itemId',
    component: SelectFigurant,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/escalar-profissional/:id/agencia/:agencyId/item/:itemId/editar',
    component: SelectFigurant,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/escalar-auxiliar/:id/agencia/:agencyId/item/:itemId',
    component: SelectFigurant,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/escalar-auxiliar/:id/agencia/:agencyId/item/:itemId/editar',
    component: SelectFigurant,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/escalar-figurante-sp/:id/agencia/:agencyId/item/:itemId',
    component: SelectFigurant,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/escalar-figurante-sp/:id/agencia/:agencyId/item/:itemId/editar',
    component: SelectFigurant,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/escalar-menor/:id/agencia/:agencyId/item/:itemId/editar',
    component: SelectFigurant,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/escalar-menor-emancipado/:id/agencia/:agencyId/item/:itemId/editar',
    component: SelectFigurant,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/escalar-veiculos/:id/agencia/:agencyId/item/:itemId/editar',
    component: SelectFigurantWithResponsible,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/escalar-animais/:id/agencia/:agencyId/item/:itemId/editar',
    component: SelectFigurantWithResponsible,
    permission: [PERMISSIONS.ESCALACAO_FIGURANTE],
    title: 'Escalação de figurantes',
  },
  {
    path: '/alvara',
    component: RegisterLicense,
    permission: [PERMISSIONS.CADASTRO_FIGURANTE_ALVARA],
    title: 'Cadastro de alvará',
  },
  {
    path: '/alvara/:id/editar',
    component: RegisterLicense,
    permission: [PERMISSIONS.CADASTRO_FIGURANTE_ALVARA],
    title: 'Editar alvará',
  },
  {
    path: '/alvara/:id/ver-mais',
    component: ViewMoreLicense,
    permission: [PERMISSIONS.CADASTRO_FIGURANTE_ALVARA],
    title: 'Busca por alvará',
  },
  {
    path: '/pedidos',
    component: OrdersFigurant,
    permission: [PERMISSIONS.BUSCA_PEDIDO_FIGURACAO],
    title: 'Pedidos de figuração',
  },
  {
    path: '/pedido/:id/editar',
    component: RequestFigurant,
    permission: [PERMISSIONS.SOLICITACAO_PEDIDO_FIGURACAO],
  },
  {
    path: '/pedidos-filtrado',
    component: OrdersFiltered,
    permission: [PERMISSIONS.BUSCA_PEDIDO_FIGURACAO],
    title: 'Pedidos de figuração',
  },
  {
    path: '/aprovacao-produtor-executivo',
    component: ApproveProducer,
    permission: [PERMISSIONS.APROVACAO_PRODUTOR_EXECUTIVO],
    title: 'Pedidos de figuração',
  },
  {
    path: '/gerenciamento-de-conteudos',
    component: ContentManagement,
    permission: [PERMISSIONS.GESTAO_CONTEUDO],
    title: 'Gerenciamento de Conteúdos',
  },
  {
    path: '/figurante-presenca',
    component: SearchCheckIn,
    permission: [PERMISSIONS.CHECKIN_FIGURANTE],
    title: 'Check in de Figurantes',
  },
  {
    path: '/figuracoes-do-dia',
    component: DailyFigurations,
    permission: [PERMISSIONS.CHECKIN_FIGURANTE],
    title: 'Figurações do dia',
  },
  {
    path: '/conferir-pedidos',
    component: CheckOrders,
    permission: [PERMISSIONS.CADASTRO_CARTA_FATURA],
    title: 'Conferir pedidos',
  },
  {
    path: '/gerar-carta-fatura',
    component: GenerateInvoiceLetter,
    permission: [PERMISSIONS.CADASTRO_CARTA_FATURA],
    title: 'Gerar carta fatura',
  },
  {
    path: '/buscar-carta-fatura',
    component: SearchInvoiceLetter,
    permission: [PERMISSIONS.BUSCA_CARTA_FATURA],
    title: 'Busca de carta fatura',
  },
  {
    path: '/recording-reports',
    component: ListRecordingReportPage,
    permission: [],
    title: 'Cadastro de ocorrências',
  },
  {
    path: '/recording-reports/:id/edit',
    component: RecordingReportAndOccurrencesPage,
    permission: [],
    title: 'Ocorrência',
  },
  {
    path: '/realizar/:id',
    component: Realize,
    permission: [PERMISSIONS.CADASTRO_CARTA_FATURA],
    title: 'Realizar',
  },
  {
    path: '/seguranca-de-transporte',
    component: TransportSecurity,
    permission: [PERMISSIONS.SEGURANCA_TRANSPORTE],
    title: 'Segurança de Transporte',
  },
  {
    path: '/reports/:typeReport',
    component: Reports,
    permission: [
      PERMISSIONS.RELATORIO_GERENCIAL,
      PERMISSIONS.RELATORIO_GERENCIAL_AGENCIA,
      PERMISSIONS.RELATORIO_ITEM_PEDIDO,
      PERMISSIONS.RELATORIO_VALORACAO,
      PERMISSIONS.RELATORIO_ALVARA_MENOR,
      PERMISSIONS.RELATORIO_PORTARIA_SEGURANCA,
      PERMISSIONS.RELATORIO_ESCALACAO_MENOR,
      PERMISSIONS.RELATORIO_FIGURANTES_BLOQUEADOS,
      PERMISSIONS.RELATORIO_SEGUROS,
      PERMISSIONS.RELATORIO_PEDIDOS_FIGURACAO,
      PERMISSIONS.RELATORIO_RESUMO_PEDIDO,
    ],
    title: 'Relatórios',
  },
  {
    path: '/report-record',
    component: ReportRecord,
    permission: [],
  },
  {
    path: '/document-Signing',
    component: DocumentSigning,
    permission: [],
    title: 'Assinatura de documento',
  },
] as Route[];

export default routes;
